import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { videoDataListsType } from "../shared/type";
// import VideoThumbnail from "./videoThumbnail";
// import { PlayIcon } from "../shared/icons";
import VideoCard from "./VideoCard";

type Props = {
  props: videoDataListsType[];
};

const VideoPlay: React.FC<Props> = ({ props }) => {
  const cardRefs = useRef<(HTMLAnchorElement | null)[]>([]);
  const [cardVisibleStates, setCardVisibleStates] = useState<boolean[]>(
    new Array(props.length).fill(false)
  );

  useEffect(() => {
    const observers: IntersectionObserver[] = [];
    cardRefs.current.forEach((ref, index) => {
      if (!ref) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setCardVisibleStates((prev) => {
              const newStates = [...prev];
              newStates[index] = true;
              return newStates;
            });
            observer.unobserve(ref);
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(ref);
      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [props.length]);

  return (
    <>
      <div className="w-full flex items-center xl:gap-x-10 gap-x-8 overflow-x-scroll scrollbar-hide">
        {props.map((item, key) => {
          return (
            <Link
              ref={(el) => {
                cardRefs.current[key] = el;
              }}
              rel="stylesheet"
              target="_top"
              to={{
                pathname: `/videopage`,
                // search: `?id=${item.id}&tags=${item.tags.join(" ")}`,
                search: `?tags=${item.tags.join(" ")}`,
              }}
              key={key}
            >
              <div
                className={`2xl:w-[300px] xl:w-[290px] lg:w-[280px] w-[280px] 2xl:h-[500px] xl:h-[480px] lg:h-[480px] h-[450px] relative rounded-xl overflow-hidden cursor-pointer group fade-in-section ${
                  cardVisibleStates[key] ? "fade-in-visible" : ""
                }`}
                style={{
                  transitionDelay: `${key * 0.1}s`,
                }}
              >
                {/* <div className="w-full h-full transition-transform duration-300 ease-out will-change-transform hover:scale-105"> */}
                {/* <VideoThumbnail
                    videoUrl={item.videoUrl}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  /> */}
                <VideoCard key={item.id} item={item} />
                {/* </div> */}
                {/* <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 z-[9] rounded-full opacity-80 group-hover:opacity-0 transition-opacity duration-300 ease-in-out">
                  <PlayIcon />
                </span> */}
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default VideoPlay;
